export default "__VITE_ASSET__BfDPQhC___"